
import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'

@Component({
    components: { ToolbarComponent },
    mixins: [ProjectMixin],
})
export default class CreateDashboard extends Mixins<MixinInterface>(ProjectMixin) {
    loading = false
    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    async createDashboard() {
        try {
            this.loading = true
            const payload = {
                type: 'dashboard',
                name: this.$t('project_menu.dashboard'),
                ...(this.group && {
                    projectGroup: {
                        data: {
                            type: 'projectGroup',
                            id: this.group.id,
                        },
                    },
                }),
                ...(this.project && {
                    project: {
                        data: {
                            type: 'project',
                            id: this.project.id,
                        },
                    },
                }),
            }

            let dashboard = await this.postDashboard(payload)

            if (dashboard?.id) {
                this.$router.push({ name: 'dashboardId', params: { dashboardId: dashboard.id } })
            }
        } finally {
            this.loading = false
        }
    }
}
